import { IFilter } from "@saleor/components/Filter";
import { FilterOpts, MinMax } from "@saleor/types";
import {
  createDateField,
  createNumberField,
  createTextField
} from "@saleor/utils/filters/fields";
import { defineMessages, IntlShape } from "react-intl";

export enum CustomerFilterKeys {
  joined = "joined",
  moneySpent = "spent",
  numberOfOrders = "orders",
  registerSite = "registerSite",
  lastIpCountry = "lastipcountry",
  fromReferral = "fromreferral"
}

export interface CustomerListFilterOpts {
  joined: FilterOpts<MinMax>;
  moneySpent: FilterOpts<MinMax>;
  numberOfOrders: FilterOpts<MinMax>;
  registerSite: FilterOpts<string>;
  lastIpCountry: FilterOpts<string>;
  fromReferral: FilterOpts<string>;
}

const messages = defineMessages({
  joinDate: {
    defaultMessage: "Join Date",
    description: "customer"
  },
  moneySpent: {
    defaultMessage: "Money Spent",
    description: "customer"
  },
  numberOfOrders: {
    defaultMessage: "Number of Orders"
  },
  registerSite: {
    defaultMessage: "Register Site",
    description: "registerSite"
  },
  lastIpCountry: {
    defaultMessage: "Last Ip Country",
    description: "lastIpCountry"
  },
  fromReferral: {
    defaultMessage: "From referral",
    description: "fromReferral"
  }
});

export function createFilterStructure(
  intl: IntlShape,
  opts: CustomerListFilterOpts
): IFilter<CustomerFilterKeys> {
  return [
    {
      ...createDateField(
        CustomerFilterKeys.joined,
        intl.formatMessage(messages.joinDate),
        opts.joined.value
      ),
      active: opts.joined.active
    },
    {
      ...createNumberField(
        CustomerFilterKeys.moneySpent,
        intl.formatMessage(messages.moneySpent),
        opts.moneySpent.value
      ),
      active: opts.moneySpent.active
    },
    {
      ...createNumberField(
        CustomerFilterKeys.numberOfOrders,
        intl.formatMessage(messages.numberOfOrders),
        opts.numberOfOrders.value
      ),
      active: opts.numberOfOrders.active
    },
    {
      ...createTextField(
        CustomerFilterKeys.registerSite,
        intl.formatMessage(messages.registerSite),
        opts.registerSite.value
      ),
      active: opts.registerSite.active
    },
    {
      ...createTextField(
        CustomerFilterKeys.lastIpCountry,
        intl.formatMessage(messages.lastIpCountry),
        opts.lastIpCountry.value
      ),
      active: opts.lastIpCountry.active
    },
    {
      ...createTextField(
        CustomerFilterKeys.fromReferral,
        intl.formatMessage(messages.fromReferral),
        opts.fromReferral.value
      ),
      active: opts.fromReferral.active
    }
  ];
}
